import { Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { boardSelector } from '../../../redux/board/reducer';
import { CHART, CHART_MENU, getChartOptions } from '../../../utils';
import { styles } from './styles';

let timer;

const ChartTypeSettings = ({ isShow, editorInfo, position, onUpdate, onOpen }) => {
  const classes = styles();
  const { objectId } = useSelector(boardSelector);
  const [selected, setSelected] = useState(0);
  const [curPosition, setCurPosition] = useState({ x: 0, y: 0 });
  const [obj, setObj] = useState({});

  const offset = 50;

  const handleChangeChartType = (chartType) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      setSelected(chartType);
      const data = obj.htmlContent;
      data.type = chartType;
      const options = getChartOptions(data);
      if (obj.id) onUpdate({ id: obj.id, data: JSON.stringify(data), options });
      clearTimeout(timer);
    }, 10);
  };

  const handleOpen = () => {
    const data = { ...obj, htmlContent: JSON.stringify(obj.htmlContent) };
    onOpen(data);
  };

  useEffect(() => {
    const box = document.getElementById('chart-box');
    const width = box?.offsetWidth || 0;
    const height = box?.offsetHeight || 0;
    setCurPosition({
      x: position?.left - width / 2 || 0,
      y: position?.top - height + offset || 0,
    });
  }, [position]);

  useEffect(() => {
    if (editorInfo.data && editorInfo.objectId.includes(CHART)) {
      const data = JSON.parse(editorInfo.data);
      setObj({ id: editorInfo.objectId || window.canvas?.getActiveObject()?.id, htmlContent: data });
      setSelected(parseInt(data.type));
    }
  }, [editorInfo.data, objectId]);

  return (
    <div
      id="chart-box"
      className={classes.panel}
      style={{
        display: isShow ? 'flex' : 'none',
        alignItems: 'center',
        ...(position ? { position: 'absolute', top: curPosition?.y || '', left: curPosition?.x || '' } : {}),
      }}
    >
      {CHART_MENU.map((c, i) => (
        <Tooltip title={c.title} key={i}>
          <button
            className={`${classes.chartButton} ${selected === i && classes.selected}`}
            onClick={() => handleChangeChartType(i)}
          >
            <img src={c.image} className={classes.chartImage} />
          </button>
        </Tooltip>
      ))}
      <Tooltip title={'Edit Data & Color'}>
        <button className={classes.chartEditButton} onClick={handleOpen}>
          Edit
        </button>
      </Tooltip>
    </div>
  );
};

export default ChartTypeSettings;
